import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: calc(100vh - 80px);
	padding: 16px;
	gap: 12px;
	box-sizing: border-box;
`;

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
`;

export const Title = styled.h1`
	margin: 0;
	font-size: 20px;
	font-weight: 600;
`;

export const StatusText = styled.span<{ tone?: 'ok' | 'warn' | 'error' }>`
	font-size: 13px;
	color: ${({ tone }) => (tone === 'error' ? '#c0392b' : tone === 'warn' ? '#b7791f' : '#666')};
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const Split = styled.div`
	flex: 1;
	display: flex;
	gap: 12px;
	min-height: 0;
`;

export const Pane = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	border: 1px solid #ddd;
	border-radius: 6px;
	overflow: hidden;
	background: #fff;
`;

export const PaneHeader = styled.div`
	padding: 8px 12px;
	border-bottom: 1px solid #eee;
	font-size: 12px;
	font-weight: 600;
	color: #555;
	text-transform: uppercase;
	letter-spacing: 0.4px;
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const EditorMount = styled.div`
	flex: 1;
	min-height: 0;
`;

export const PreviewFrame = styled.iframe`
	flex: 1;
	width: 100%;
	border: 0;
	background: #fff;
`;

export const ActionBar = styled.div`
	display: flex;
	gap: 8px;
`;

export const ActionButton = styled.button<{ kind?: 'primary' | 'secondary' }>`
	padding: 8px 14px;
	border-radius: 6px;
	font-size: 14px;
	cursor: pointer;
	border: 1px solid ${({ kind }) => (kind === 'primary' ? '#1f9d55' : '#ccc')};
	background: ${({ kind }) => (kind === 'primary' ? '#1f9d55' : '#fff')};
	color: ${({ kind }) => (kind === 'primary' ? '#fff' : '#333')};
	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const Input = styled.input`
	padding: 6px 10px;
	border: 1px solid #ccc;
	border-radius: 6px;
	font-size: 13px;
`;
